import { observer } from 'mobx-react';
import { IBenefitsRewardsTableThead } from '~views/marketing-page/benefits-rewards/IBenefitsRewards';
import { BenefitsRewardsTableHeader } from '~views/marketing-page/benefits-rewards/BenefitsRewardsTableHeader';
import * as React from 'react';
import { classes } from '~utils/Classes';

const benefitsRewardsTableHeadClass = 'loyalty-marketing-page-benefits-rewards__tableHead';
const benefitsRewardsTableLogoWrapperClass = classes(
    'loyalty-marketing-page-benefits-rewards__table__logoWrapper'
);
const benefitsRewardsTableColumnHeadersClass = classes(
    'loyalty-marketing-page-benefits-rewards__table__columnHeaders'
);

export const BenefitsRewardsTableThead = observer(function BenefitsRewardsTableThead({
    data,
    textColor,
    tableLogo
}: IBenefitsRewardsTableThead) {
    return (
        <thead className={benefitsRewardsTableHeadClass}>
            <tr className={benefitsRewardsTableColumnHeadersClass}>
                <th className={benefitsRewardsTableLogoWrapperClass}>
                    <img src={tableLogo.src} alt={tableLogo.alt} />
                </th>
                {data.map((item, index) => (
                    <BenefitsRewardsTableHeader
                        heading={item.benefits.heading}
                        shortDescription={item.benefits.shortDescription}
                        levelName={item.benefits.levelName}
                        textColor={textColor}
                        tierColor={item.benefits.levelColor}
                        tier={index + 1}
                        key={index}
                    />
                ))}
            </tr>
        </thead>
    );
});
